<div fxLayout="row" fxLayoutAlign="space-between center" id="ts-paginator" >
    <div class="column">
      <h2 class="row">{{ "tunnel-sections.title" | translate }}</h2>
      <mat-paginator
      [length]="totalElements"
      [pageSizeOptions]="[ 10, 25, 400]"
      [pageSize]="this.defaultPageSize"
      #paginator
      showFirstLastButtons
      (page)="this.handlePageEvent($event)"
    ></mat-paginator>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="end center"
      class="searchbox"
    >
      <app-table-search [allFields]="filterFields" (filterChangedEmitter)="filterchanged($event)" style="margin-right: 15px;"></app-table-search>
      <div *ngIf="topMenuIcons.length > 0">
        <button
          mat-raised-button
          *ngFor="let action of topMenuIcons"
          [routerLink]="action.routerLink"
          (click)="this[action.clickMethod]()"
        >
          <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
        </button>
      </div>
      <button
        mat-raised-button
        (click)="exporter.exportTable('xlsx', {fileName:exportPrefix+formatted})">
        <mat-icon
          [title]="titleExcel">download
        </mat-icon>
      </button>
    </div>
  </div>

  <div class="top-table-sticky-header">
  <mat-table
    [dataSource]="dataSource"
    [paginator]="paginator"
    class="mat-elevation-z8"
    matSort
    [matSortActive]="this.defaultSort.active"
    [matSortDirection]="this.defaultSort.direction"
    matSortDisableClear
    appNgMatTableQueryReflector
    matTableExporter
    #exporter="matTableExporter"
    [hiddenColumns]="[0]"
  >
    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle">
        {{ "tunnel-section.id" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.id" | translate) + ":"'>
         {{ element.id }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "tunnel-section.name" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.name" | translate) + ":"'>
        {{ element.name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="startChainage">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "tunnel-section.start-chainage" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.start-chainage" | translate) + ":"'>
        {{ element.startChainage }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="maxPrecSpecs">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "tunnel-section.max-prec-specs" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.max-prec-specs" | translate) + ":"'>
        {{ (element?.maxPrecSpecs ?? 0)  | number : '.0-3' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="length">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "tunnel-section.length" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.length" | translate) + ":"'>
        {{ element.length | number : '.0-3' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="width">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "tunnel-section.width" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.width" | translate) + ":"'>
        {{ element.width | number : '.0-3' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="stressPatternAvg">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "tunnel-section.stress-pattern-avg" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.stress-pattern-avg" | translate) + ":"'>
        {{ element.stressPatternAvg | number : '.0-3' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="calcStatus">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "tunnel-section.calc-status" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.calc-status" | translate) + ":"'>
        {{ element.calcStatus }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tunnelStatus">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "tunnel-section.tunnel-status" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.tunnel-status" | translate) + ":"'>
        {{ element.tunnelStatus }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="calculationInProgress">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "tunnel-section.calculationInProgress" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element; let i = index" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.calculationInProgress"| translate) + ":"'>
        <mat-icon  *ngIf="element.calculationInProgress && element.calculationInProgress==true"> checked </mat-icon>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "tunnel-section.creation-date" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.creation-date" | translate) + ":"'>
          {{ element.created | date : 'yyyy-MM-dd HH:mm' }}
        </mat-cell>
      </ng-container>

    <ng-container matColumnDef="lastModificationDate">
        <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
          {{ "tunnel-section.modification-date" | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.modification-date" | translate) + ":"'>
          {{ element.lastModificationDate | date : 'yyyy-MM-dd HH:mm' }}
        </mat-cell>
      </ng-container>

    <ng-container matColumnDef="latestError">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" mat-sort-header>
        {{ "tunnel-section.latest-error" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title has_label_on_mobile" [attr.data-label]='("tunnel-section.latest-error" | translate) + ":"'>
        {{ element.latestError }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef [style]="headerStyle" class="one_actions"> </mat-header-cell>
      <mat-cell *matCellDef="let element" class="m-card-title one_actions">
        <div *ngIf="actions.length > 0">
          <button
            class="icon-button"
            *ngFor="let action of actions"
            [state]="{ listdata: listIds }"
            [routerLink]="action.routerLink + element.id"
            (click)="this[action.clickMethod](element.id)"
            [state]="{ listdata: listIds }"
          >
            <mat-icon [title]="action.title"> {{ action.icon }} </mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" (click)="clickedRow(row.id)"
    [class.rowClicked]="clickedRowId == row.id"></mat-row>
  </mat-table>
  </div>





